import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { NavBarMain } from "..";
import { checkIfTokenStillValid } from "../../repositories/utils";
import { useEvents } from "../../hooks";
import { EventsSection } from "./components/EventsSection";
import { PageContainer, ContentArea, WidgetsContainer } from './UserHome.styled';

export const UserHome = ({ history }) => {
  const { t } = useTranslation();
  const { getEvents, getUpcomingEvents } = useEvents();
  const [events, setEvents] = useState({});
  const [upcomingEvents, setUpcomingEvents] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      checkIfTokenStillValid(history);
      const [fetchedEvents, fetchedUpcomingEvents] = await Promise.all([
        getEvents(),
        getUpcomingEvents(),
      ]);
      setEvents(fetchedEvents);
      setUpcomingEvents(fetchedUpcomingEvents);
    };
    fetchData();
  }, [getEvents, getUpcomingEvents, history]);

  return (
    <PageContainer>
      <NavBarMain currentPage="home" history={history} />
      <ContentArea>
        <WidgetsContainer>
          <EventsSection
            events={events}
            upcomingEvents={upcomingEvents}
            t={t}
          />
        </WidgetsContainer>
      </ContentArea>
    </PageContainer>
  );
};
